import { makeStyles } from '@material-ui/core/styles';

export const useGoBackButton = makeStyles(() => ({
  button: {
    padding: 0,
    margin: 0,
    paddingRight: '4px',
    height: '24px',
    '& > span > span': {
      display: 'flex',
      flexWrap: 'nowrap',
      alignItems: 'center',
      justifyContet: 'end',
    },
  },
}));
